<ng-template #inline let-nodes>
  @for (node of nodes; track $index) {
    @switch (node.kind) {
      @case ('strong') {
        <strong><ng-container *ngTemplateOutlet="inline; context: { $implicit: node.children }"></ng-container></strong>
      }
      @case ('em') {
        <em><ng-container *ngTemplateOutlet="inline; context: { $implicit: node.children }"></ng-container></em>
      }
      @case ('link') {
        <a [href]="node.href" target="_blank" rel="noopener noreferrer"><ng-container *ngTemplateOutlet="inline; context: { $implicit: node.children }"></ng-container></a>
      }
      @default {
        <ng-container>{{ node.text }}</ng-container>
      }
    }
  }
</ng-template>

<ng-template #cell let-node>
  @switch (node.type) {
    @case ('grid') {
      <div class="lx-cell lx-grid" [attr.data-id]="node.id" [style]="node.style">
        @for (child of node.children; track $index) {
          <ng-container *ngTemplateOutlet="cell; context: { $implicit: child }"></ng-container>
        }
      </div>
    }
    @case ('text') {
      <div class="lx-cell" [attr.data-id]="node.id" [style]="node.style">
        @if (node.text) {
          <div class="lx-text" [style]="node.contentStyle">{{ node.text }}</div>
        }
      </div>
    }
    @case ('markdown') {
      <div class="lx-cell" [attr.data-id]="node.id" [style]="node.style">
        @if (node.blocks.length) {
          <div class="lx-md" [style]="node.contentStyle">
            @for (block of node.blocks; track $index) {
              @if (block.kind === 'list') {
                <ul>
                  @for (item of block.items; track $index) {
                    <li><ng-container *ngTemplateOutlet="inline; context: { $implicit: item }"></ng-container></li>
                  }
                </ul>
              } @else {
                <p><ng-container *ngTemplateOutlet="inline; context: { $implicit: block.children }"></ng-container></p>
              }
            }
          </div>
        }
      </div>
    }
    @case ('image') {
      <div class="lx-cell" [attr.data-id]="node.id" [style]="node.style">
        @if (node.src) {
          <img class="lx-image" [src]="node.src" [alt]="node.alt" [style]="node.contentStyle" (error)="hideImage($event)" (load)="showImage($event)" />
        }
      </div>
    }
  }
</ng-template>

@if (view) {
<div class="w-full min-w-0 lx-root">
  @if (config?.printEnabled !== false) {
    <div class="lx-toolbar print:hidden">
      <button type="button"
        class="px-3 py-2 ml-auto text-xs font-bold bg-white border rounded-sm shadow-sm md:text-sm text-th-primary"
        (click)="print()">
        {{ printLabel }}
      </button>
    </div>
  }

  <div #viewport class="lx-viewport">
    <div #sheets class="lx-sheets">
      @for (sheet of view.sheets; track $index) {
        <div class="lx-scaler"
          [style.width.px]="view.geometry.width * scale"
          [style.height.px]="view.geometry.height * scale">
          <div class="lx-sheet"
            [attr.data-page]="sheet.id"
            [style.width.px]="view.geometry.width"
            [style.height.px]="view.geometry.height"
            [style.padding.px]="view.geometry.margin"
            [style.transform]="'scale(' + scale + ')'">
            @if (sheet.header) {
              <ng-container *ngTemplateOutlet="cell; context: { $implicit: sheet.header }"></ng-container>
            }
            <ng-container *ngTemplateOutlet="cell; context: { $implicit: sheet.body }"></ng-container>
            @if (sheet.footer) {
              <ng-container *ngTemplateOutlet="cell; context: { $implicit: sheet.footer }"></ng-container>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
}
